import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import NewPostbackTemplate from './NewPostbackTemplate'
import { lang } from '../../assets/lang'

export default class NewPostbackComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.POSTBACK_NEW)

    this.data.component = NewPostbackTemplate
    this.socket = config ? config.sockets : null
    this.isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
    this.isConditionAddonAvailable = !! window.xitFlowBuilderData.messenger_bot_condition
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !!window.xitFlowBuilderData.is_openai_addon_access
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder (node) {
    node.lingualName = lingualName.POSTBACK_NEW
    this.setConnection()

    const triggerInput = new Rete.Input(
      CONST_SOCKET.NEW_POSTBACK_INPUT_TRIGGER, 
      lang.postback_new_socket_input_trigger, 
      this.socket.newPostbackInputTrigger, 
      true
    )

    node.addInput(triggerInput)
    
    const newPostbackInput = new Rete.Input(
      CONST_SOCKET.NEW_POSTBACK_INPUT, 
      lang.postback_new_socket_input_reply, 
      this.socket.newPostbackInput, 
      true
    )

    node.addInput(newPostbackInput)
    
    const newPostbackOutput = new Rete.Output(
      CONST_SOCKET.NEW_POSTBACK_OUTPUT, 
      lang.postback_new_socket_output_next, 
      this.socket.newPostbackOutput,
      false
    )

    node.addOutput(newPostbackOutput)

    if (this.isSequenceAddonAvailable) {
      const newPostbackOutputSequence = new Rete.Output(
        CONST_SOCKET.NEW_POSTBACK_OUTPUT_SEQUENCE, 
        lang.postback_new_socket_output_sequence, 
        this.socket.newPostbackOutputSequence,
        false
      )

      node.addOutput(newPostbackOutputSequence)
    }

    return node
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.NEW_POSTBACK_OUTPUT] = node.data
  }

  setConnection() {
    // NewPostback may take connections from:
    this.socket.newPostbackInput.combineWith(this.socket.quickReplyOutput)
    this.socket.newPostbackInput.combineWith(this.socket.buttonOutput)

    // NewPostback may be connected to:
    this.socket.newPostbackOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.newPostbackOutput.combineWith(this.socket.openaiInput)
    this.socket.newPostbackOutput.combineWith(this.socket.carouselInput)
    this.socket.newPostbackOutput.combineWith(this.socket.imageInput)
    
    if (!this.isInstagramAddonAvailable) {
      this.socket.newPostbackOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.newPostbackOutput.combineWith(this.socket.videoInput)
      this.socket.newPostbackOutput.combineWith(this.socket.audioInput)
      this.socket.newPostbackOutput.combineWith(this.socket.fileInput)
      this.socket.newPostbackOutput.combineWith(this.socket.otnInput)
      if(this.isRcnAddonAvailable)
        this.socket.newPostbackOutput.combineWith(this.socket.rcnInput)
    }

    this.socket.newPostbackOutput.combineWith(this.socket.ecommerceInput)
    this.socket.newPostbackOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.newPostbackOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.newPostbackOutput.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.newPostbackOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Input: Triggers
    this.socket.newPostbackInputTrigger.combineWith(this.socket.triggerOutput)    

    // Output: Sequence
    if (this.isSequenceAddonAvailable) {
      this.socket.newPostbackOutputSequence.combineWith(this.socket.sequenceInput)    
    }
    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.newPostbackOutput.combineWith(this.socket.conditionInput)
    }
  }  
}